const CARD_EXPIRY_PATTERN = /^(0[1-9]|1[0-2])\/(\d{2})$/;

export const isCardExpiryValid = (expiry: string, today = new Date()) => {
  const match = CARD_EXPIRY_PATTERN.exec(expiry);
  if (!match) {
    return false;
  }

  const month = Number(match[1]);
  const year = 2000 + Number(match[2]);
  const currentYear = today.getFullYear();

  return (
    year > currentYear ||
    (year === currentYear && month >= today.getMonth() + 1)
  );
};
